import {
  CREDIT_DIALOG_ACTION_EVENT,
  CREDIT_DIALOG_EVENT,
  type CreditDialogParams,
  LEARN_MORE_EVENT,
  creditDialogProps,
} from "@repo/shared/analytics";

import { mixpanelTrack } from "./mixpanelTrack";

// Credit-gate dialog client-side Mixpanel events. Only what the user does with
// the dialog lives here; every credit *spend* is fired server-side in
// peareasy-services, since the backend is what debits.
//
// The vocabulary — event names, `section`, `subsection`, `context` — lives in
// @repo/shared/analytics so web and mobile stay one taxonomy. Web keeps its own
// transport (mixpanelTrack) and reuses the prop builder; mobile sends the same
// events through the shared analytics port. Same split as sbcMixpanel.

export type { CreditDialogContext } from "@repo/shared/analytics";

/** The dialog was shown. Denominator for everything below. */
export const trackCreditDialog = (params: CreditDialogParams) =>
  mixpanelTrack(CREDIT_DIALOG_EVENT, creditDialogProps(params));

/**
 * How the dialog was left — the offer taken or not. Deliberately not the button
 * label: "Maybe later", the X and Escape are one answer, and every dialog
 * having its own vocabulary would make the exits impossible to compare.
 */
export const trackCreditDialogAction = (
  params: CreditDialogParams & { value: "positive" | "negative" },
) =>
  mixpanelTrack(CREDIT_DIALOG_ACTION_EVENT, {
    ...creditDialogProps(params),
    value: params.value,
  });

/**
 * "Learn more" — the only exit that leads to the pricing page. Same event the
 * SBC side panel already fires (see sbcMixpanel.ts), so the two read together.
 */
export const trackLearnMore = (params: CreditDialogParams) =>
  mixpanelTrack(LEARN_MORE_EVENT, creditDialogProps(params));
